// Maison Parlour — theme JS
// Accordion + mobile menu + product page interactions

document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  var menu = document.getElementById('mobileMenu');
  if (menu) {
    document.querySelectorAll('.menu-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        menu.setAttribute('aria-hidden', String(!open));
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });
  }

  // Accordion
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      var open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(open));
    });
  });

  // Swatches
  document.querySelectorAll('.swatches').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.swatch');
      if (!btn) return;
      group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var input = document.querySelector('input[name="id"]');
      if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
    });
  });

  // Size selection
  document.querySelectorAll('.size-options').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      group.querySelectorAll('button').forEach(function (s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var input = document.querySelector('input[name="id"]');
      if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
    });
  });

  // Size guide link → open the pop-up modal
  var sizeModal = document.getElementById('sizeModal');
  function openSizeModal() {
    if (!sizeModal) return;
    sizeModal.classList.add('is-open');
    sizeModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-modal-open');
  }
  function closeSizeModal() {
    if (!sizeModal) return;
    sizeModal.classList.remove('is-open');
    sizeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-modal-open');
  }
  document.querySelectorAll('[data-size-guide]').forEach(function (link) {
    link.addEventListener('click', function (e) { e.preventDefault(); openSizeModal(); });
  });
  document.querySelectorAll('[data-size-close]').forEach(function (el) {
    el.addEventListener('click', closeSizeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sizeModal && sizeModal.classList.contains('is-open')) closeSizeModal();
  });

  // Gallery dots → change the main image
  (function () {
    var gMain = document.getElementById('galleryMain');
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gallery-dot'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumbs img'));
    if (!gMain || dots.length === 0) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');
        var t = thumbs[i];
        if (t) gMain.src = t.dataset.full || t.src;
      });
    });
  })();

  // Quantity controls
  document.querySelectorAll('.qty-control').forEach(function (group) {
    var input = group.querySelector('input');
    var btns = group.querySelectorAll('button');
    if (!input || btns.length < 2) return;
    btns[0].addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    btns[1].addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // Gallery thumbs
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) {
    document.querySelectorAll('.gallery-thumbs img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.gallery-thumbs img').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var full = thumb.dataset.full || thumb.src;
        galleryMain.src = full;
      });
    });
  }

  // Sticky mobile ATC
  var atc = document.querySelector('.add-to-cart');
  var sticky = document.getElementById('stickyAtc');
  if (atc && sticky && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) sticky.classList.remove('is-visible');
        else sticky.classList.add('is-visible');
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    observer.observe(atc);
  }
});


// ===== Client revisions — June 2026 =====
document.addEventListener('DOMContentLoaded', function () {

  // Header: solid background once scrolled past the hero (overlay headers only)
  var header = document.querySelector('.site-header--overlay');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Collection filters: tap to toggle on touch devices
  document.querySelectorAll('.filter-trigger').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var dd = btn.parentElement.querySelector('.filter-dropdown');
      if (!dd) return;
      var open = dd.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.filter-group')) return;
    document.querySelectorAll('.filter-dropdown.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      var t = dd.parentElement.querySelector('.filter-trigger');
      if (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
    });
  });

  // Product gallery: prev/next arrows cycle through the thumbnails
  var gMain = document.getElementById('galleryMain');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumbs img'));
  if (gMain && thumbs.length > 1) {
    var step = function (dir) {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (i < 0) i = 0;
      i = (i + dir + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[i].classList.add('is-active');
      gMain.src = thumbs[i].dataset.full || thumbs[i].src;
    };
    var prev = document.querySelector('.gallery-prev');
    var next = document.querySelector('.gallery-next');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }
});


// Collection sidebar — mobile filter toggle
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sidebar-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var side = btn.closest('.collection-sidebar');
      if (!side) return;
      var open = side.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });
});


// ===== Client revisions — July 2026 =====
document.addEventListener('DOMContentLoaded', function () {

  // Product gallery: preload every full-size photo in the background so
  // clicking a thumbnail / dot / arrow is instant instead of fetching cold.
  (function () {
    var thumbs = document.querySelectorAll('.gallery-thumbs img[data-full]');
    if (thumbs.length < 2) return;
    var preload = function () {
      thumbs.forEach(function (t) {
        var url = t.getAttribute('data-full');
        if (!url) return;
        var img = new Image();
        img.src = url;
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preload, { timeout: 2000 });
    } else {
      setTimeout(preload, 300);
    }
  })();

  // Product gallery: tap the main image to advance, or swipe/drag anywhere
  // across the photo (not just the arrows) to move between photos.
  (function () {
    var main = document.getElementById('galleryMain');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumbs img'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gallery-dot'));
    if (thumbs.length < 2) return;

    function go(dir) {
      var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (cur < 0) cur = 0;
      var idx = (cur + dir + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[idx].classList.add('is-active');
      main.src = thumbs[idx].dataset.full || thumbs[idx].src;
      if (dots.length) {
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
    }

    var startX = null, startY = null, swiped = false;
    var THRESHOLD = 40; // px of horizontal travel before it counts as a swipe

    function onStart(x, y) { startX = x; startY = y; swiped = false; }
    function onEnd(x, y) {
      if (startX === null) return;
      var dx = x - startX, dy = y - startY;
      startX = startY = null;
      if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        go(dx < 0 ? 1 : -1); // swipe left → next, swipe right → previous
      }
    }

    main.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      onStart(t.clientX, t.clientY);
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      onEnd(t.clientX, t.clientY);
    }, { passive: true });

    // Mouse drag for desktop
    main.addEventListener('mousedown', function (e) { onStart(e.clientX, e.clientY); });
    main.addEventListener('mouseup', function (e) { onEnd(e.clientX, e.clientY); });
    main.addEventListener('dragstart', function (e) { e.preventDefault(); });

    main.addEventListener('click', function () {
      if (swiped) { swiped = false; return; } // ignore the click that follows a swipe
      go(1);
    });
  })();

  // Product variant picker: selected options → live price, variant id, availability
  (function () {
    var form = document.querySelector('.product-form');
    if (!form) return;
    var dataEl = form.querySelector('[data-product-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.getElementById('productPrice');
    var stickyPriceEl = document.querySelector('.sticky-atc .price-label');
    var atcBtn = form.querySelector('.add-to-cart');
    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      function amount(precision, thousands, decimal) {
        if (precision == null) precision = 2;
        thousands = thousands || ',';
        decimal = decimal || '.';
        var value = (cents / 100.0).toFixed(precision);
        var parts = value.split('.');
        var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return dollars + (parts[1] ? decimal + parts[1] : '');
      }
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount(0))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount(2, '.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amount(0, '.', ','));
    }

    function selectedValues() {
      var vals = [];
      form.querySelectorAll('[data-option-position]').forEach(function (g) {
        var pos = parseInt(g.getAttribute('data-option-position'), 10);
        var sel = g.querySelector('.is-selected');
        vals[pos - 1] = sel ? sel.getAttribute('data-value') : null;
      });
      return vals;
    }

    function findVariant(vals) {
      return variants.filter(function (v) {
        var opts = v.options || [];
        return vals.every(function (val, i) { return val == null || val === opts[i]; });
      })[0];
    }

    function update() {
      var v = findVariant(selectedValues());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var priceStr = formatMoney(v.price);
      if (priceEl) priceEl.textContent = priceStr;
      if (stickyPriceEl) stickyPriceEl.textContent = priceStr;
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    form.querySelectorAll('[data-option-position] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-position]');
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        update();
      });
    });

    update();
  })();

  // Product description: strip trailing blank paragraphs Shopify's editor
  // sometimes leaves behind (extra Enter presses) that show as empty gaps.
  (function () {
    document.querySelectorAll('.product-description').forEach(function (block) {
      block.querySelectorAll('p').forEach(function (p) {
        var isBlank = !/\S/.test(p.textContent);
        var hasMedia = p.querySelectorAll('img, br').length > 0;
        if (isBlank && !hasMedia) { p.remove(); }
      });
    });
  })();

  // First-visit newsletter pop-up (shows once; remembers via localStorage)
  (function () {
    var popup = document.getElementById('mpPopup');
    if (!popup) return;
    var KEY = 'mp_popup_seen';
    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mp-popup-open');
    }
    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mp-popup-open');
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }
    var posted = popup.querySelector('.mp-popup__success');
    if (posted) {
      open();
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    } else {
      var seen = null;
      try { seen = localStorage.getItem(KEY); } catch (e) {}
      if (!seen) { setTimeout(open, 1200); }
    }
    popup.querySelectorAll('[data-mp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });
  })();

  // "Loved by you" photo strip: prev/next arrows for desktop (no trackpad needed)
  document.querySelectorAll('.lby-strip-wrap').forEach(function (wrap) {
    var strip = wrap.querySelector('.lby-strip');
    var prev = wrap.querySelector('.lby-arrow-prev');
    var next = wrap.querySelector('.lby-arrow-next');
    if (!strip) return;
    var scrollByAmount = function (dir) {
      var item = strip.querySelector('.lby-item');
      var step = item ? item.getBoundingClientRect().width + 12 : strip.clientWidth * 0.8;
      strip.scrollBy({ left: step * dir, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
    if (next) next.addEventListener('click', function () { scrollByAmount(1); });
  });

});


// Cart page: quantity +/- and manual quantity entry
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cart-qty').forEach(function (box) {
    var line = parseInt(box.getAttribute('data-cart-line'), 10);
    var input = box.querySelector('[data-cart-qty-input]');
    if (!line || !input) return;

    function setQty(qty) {
      qty = Math.max(0, parseInt(qty, 10) || 0);
      box.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        window.location.reload();
      });
    }

    box.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-cart-qty'), 10);
        setQty((parseInt(input.value, 10) || 0) + delta);
      });
    });
    input.addEventListener('change', function () { setQty(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); setQty(input.value); }
    });
  });
});

/* Mobile slide-out cart */
(function () {
  var drawer = document.getElementById('cartDrawer');
  if (!drawer) return;
  var panel = drawer.querySelector('.cart-drawer__panel');
  var mq = window.matchMedia('(max-width: 767px)');

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  function refresh() {
    return Promise.all([
      fetch('/?sections=cart_drawer').then(function (r) { return r.json(); }),
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var wrap = document.getElementById('shopify-section-cart_drawer');
      var doc = new DOMParser().parseFromString(res[0].cart_drawer, 'text/html');
      var fresh = doc.querySelector('.cd');
      var old = wrap && wrap.querySelector('.cd');
      if (fresh && old) old.replaceWith(fresh);
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = '(' + res[1].item_count + ')'; });
    });
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    var q = e.target.closest('[data-drawer-qty]');
    if (q) {
      q.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(q.getAttribute('data-drawer-qty'), 10), quantity: parseInt(q.getAttribute('data-qty'), 10) })
      }).then(refresh).catch(function () { window.location.href = '/cart'; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Header cart icon
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"], a[aria-label="Cart"]');
    if (!a || a.closest('#cartDrawer')) return;
    e.preventDefault();
    refresh().then(open);
  });

  drawer.addEventListener('click', function (e) {
    var add = e.target.closest('[data-drawer-add]');
    if (!add) return;
    var sel = add.closest('.cd__card').querySelector('select');
    add.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: sel ? sel.value : add.getAttribute('data-drawer-add'), quantity: 1 })
    }).then(refresh).catch(function () { add.disabled = false; });
  });

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.product-form')) return;
    e.preventDefault();
    var btn = form.querySelector('.add-to-cart');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(refresh)
      .then(open)
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });
})();
